import TablasPosiciones from './TablaPosiciones';
import { ButtonFollowFriend, PopUpConfirmationAdd , Strikes } from './TablaPosiciones'

export { ButtonFollowFriend, PopUpConfirmationAdd, Strikes } ;
// export { PopUpConfirmationAdd } ;

export default TablasPosiciones;
